<template>
    <card>
        <h3 class="mb-0" slot="header">{{ $t('common.actions') }}</h3>

        <p>{{ $t('users.invitation-description') }}</p>
                    
        <div class="text-center mt-4 mb-3">
            <base-button
                type="primary"
                :loading="sending"
                @click="invite"
            >
                {{ $t('users.invite') }}
            </base-button>
        </div>

        <p class="text-center text-danger" v-if="error">
            <small>{{ error }}</small>
        </p>
    </card>
</template>

<script>
    export default {

        props: {
            id: {
                type: [String, Number],
                required: true
            },
        },

        data() {
            return {
                endpoint: this.$baseURL + '/astral/api/front/users/' + this.id + '/invite',
                sending: false,
                error: false,
            }
        },

        methods: {
            invite() {
                this.sending = true
                this.error = false
                axios.post(this.endpoint)
                    .then(resp => {
                        this.sending = false
                        this.$notify({type: 'primary', message: this.$t('users.invitation-success') })
                    })
                    .catch(err => {
                        this.sending = false
                        if (err.response.status == 400) {
                            this.error = this.$t('users.invitation-error-400');
                        } else if (err.response.status == 500) {
                            this.error = this.$t('users.invitation-error-500')
                        } else {
                            this.$auth.handleErrorVm(err, this)
                        }
                    });
            },
        }
    }
</script>

